var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.5C0 4.26154 4.26154 0 9.5 0C14.7385 0 19 4.26154 19 9.5C19 14.7385 14.7385 19 9.5 19C4.26154 19 0 14.7385 0 9.5ZM11.0833 12.6667C12.8234 12.6667 14.2769 13.7995 14.8026 15.3615C16.4033 13.912 17.4167 11.8243 17.4167 9.5C17.4167 5.13475 13.8653 1.58333 9.5 1.58333C5.13475 1.58333 1.58333 5.13475 1.58333 9.5C1.58333 11.8251 2.59746 13.9128 4.199 15.3623C4.72467 13.8003 6.17658 12.6667 7.91667 12.6667H11.0833Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50004 3.95703C7.75125 3.95703 6.33337 5.37491 6.33337 7.1237V7.91536C6.33337 9.66416 7.75125 11.082 9.50004 11.082C11.2488 11.082 12.6667 9.66416 12.6667 7.91536V7.1237C12.6667 5.37491 11.2488 3.95703 9.50004 3.95703Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.5d6c5b31.svg";
export { ForwardRef as ReactComponent };